// File: frontend/src/config/publicSupport.js
//
// THE ONE PUBLIC SUPPORT LINE.
//
// Every public way to reach PesaFii (the floating WhatsApp button, the Contact
// page, the footer, the wallet's "network unavailable" notice) builds its link
// from here, so changing the number is one edit.
//
// Not covered: the captive-portal "Need help?" default in
// components/PortalCustomizer.js and backend/utils/portalRenderer.js. That is a
// per-tenant setting shown to an operator's own customers, and it has its own
// lifecycle.
//
// Prefilled WhatsApp messages differ by page, so support can see where a chat
// came from without any tracking. They must never carry account data (user or
// tenant ids, balances, payment references, tokens): the text opens in the
// visitor's own WhatsApp.

export const SUPPORT_PHONE_E164 = "+256790889056";
export const SUPPORT_PHONE_DISPLAY = "0790 889 056";
export const SUPPORT_WHATSAPP_NUMBER = "256790889056";

export const WHATSAPP_MESSAGES = Object.freeze({
  general: "Hi PesaFii, I'd like to know more about selling Wi-Fi with PesaFii.",
  ambassador: "Hi PesaFii, I'm interested in the PesaFii Ambassador programme.",
  customer: "Hi PesaFii, I already use PesaFii and I need help with my account.",
});

/** A wa.me deep link to the support line, optionally with a prefilled message. */
export function whatsappUrl(message) {
  const base = `https://wa.me/${SUPPORT_WHATSAPP_NUMBER}`;
  return message ? `${base}?text=${encodeURIComponent(message)}` : base;
}

export const SUPPORT_TEL_HREF = `tel:${SUPPORT_PHONE_E164}`;
